import { render, staticRenderFns } from "./MainNavbarChadMain.vue?vue&type=template&id=0bdb7c22&scoped=true&"
import script from "./MainNavbarChadMain.vue?vue&type=script&lang=js&"
export * from "./MainNavbarChadMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb7c22",
  null
  
)

export default component.exports